import React, { Children, Component, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { HashLink as Link } from 'react-router-hash-link';

const HitLinkHandler = ({
  id,
  essentails_chapter,
  number,
  chapter_id,
  category,
  routeTitle,
  url,
  type,
  typeHit,
  children,
}) => {
  const [route, setRoute] = useState({ route: '', type: '' });

  useEffect(() => {
    if (typeHit === 'chapter') {
      const chapterPath = '/main/retain/chapter/';
      const chapterDetails = id + '/' + (essentails_chapter - 1);
      setRoute({ ...route, route: chapterPath + chapterDetails, type: 'internal' });
    }
    if (typeHit === 'pages') {
      const pagesPath = '/main/retain/chapter/';
      const pagesDetails = chapter_id + '/' + (number - 1);
      setRoute({ ...route, route: pagesPath + pagesDetails, type: 'internal' });
    }
    if (typeHit === 'hit') {
      hitRouter(category, routeTitle, url, type);
    }
  }, [id, essentails_chapter, number, chapter_id, category, routeTitle, url, type, typeHit]);

  const hitRouter = (category, routeTitle, url, type) => {
    let path = '/main/promote/';
    if (category === 'toolbox') {
      path = '/main/sell/';
    }
    switch (type) {
      case 'collection':
        let collectionTitle = routeTitle;
        let Cdetails = collectionTitle.toLowerCase();
        Cdetails = Cdetails.split(' ').join('-');
        setRoute({ ...route, route: path, type: 'internal' });
        break;
      case 'image_library':
        let imgLibraryTitle = url;
        let imgLDetails = imgLibraryTitle.toLowerCase();
        imgLDetails = imgLDetails.split(' ').join('-');
        setRoute({ ...route, route: path + imgLDetails, type: 'internal' });
        break;
      case 'pdf':
        setRoute({ ...route, route: url, type: 'pdf' });
        break;
      case 'iframe-link':
      case 'weblink':
        setRoute({ ...route, route: url, type: 'weblink' });
        break;
      case 'videolink':
      case 'infographic':
        setRoute({ ...route, route: url, type: 'fancyBox' });
        break;
    }
  };

  {
    switch (route.type) {
      case 'internal':
        return (
          <div>
            <Link to={route.route}>{children}</Link>
          </div>
        );
      case 'pdf':
        return (
          <a
            href={`https://stack.travpromobile.com/viewer.php?file=${route.route}#zoom=75`}
            fancybox={`https://stack.travpromobile.com/viewer.php?file=${route.route}#zoom=75`}
            data-fancybox-trigger={route.route}
            data-fancybox={route.route}
          >
            {children}
          </a>
        );
      case 'weblink':
        return (
          <a href={route.route} target="_blank">
            {children}
          </a>
        );
      case 'fancyBox':
        return (
          <a href={route.route} fancybox={route.route} data-fancybox-trigger={route.route} data-fancybox={route.route}>
            {children}
          </a>
        );
      default:
        return <a href={route.route}>{children}</a>;
    }
  }
};

HitLinkHandler.propTypes = {
  id: PropTypes.number,
  essentails_chapter: PropTypes.number,
};
export default HitLinkHandler;
